<div class="row modal-bar">
  <div class="col-sm-6">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="form" class="form-content">
  <div class="section-wrapper">
    <div class="form-layout">
      <div class="row">
        <div class="col-lg-12">
          @if (cannotChangeCapacity) {
            <div class="alert alert-warning">
              {{ 'DIALOGS.EDIT-UNPLACED-EVENT-CAPACITY.WARNING.CAPACITY-CANNOT-BE-CHANGED' | translate: { minCapacity: minCapacity, maxCapacity: maxCapacity } }}
            </div>
          }

          <div class="form-group">
            <label class="form-control-label">{{ 'DIALOGS.EDIT-UNPLACED-EVENT-CAPACITY.FORM.LABEL.NEW-CAPACITY' | translate }}<span class="tx-danger">*</span></label>
            <input
              class="form-control"
              name="NrOfTickets"
              formControlName="NrOfTickets"
              type="number"
              [attr.min]="minCapacity"
              [attr.max]="maxCapacity"
            >
            <small class="form-text text-muted">
              {{ 'DIALOGS.EDIT-UNPLACED-EVENT-CAPACITY.FORM.HINT.CAPACITY-RANGE' | translate: { minCapacity: minCapacity, maxCapacity: maxCapacity, currentAvailableTickets: currentAvailableTickets, unsoldExternalBarcodesCount: unsoldExternalBarcodesCount, soldExternalBarcodesCount: soldExternalBarcodesCount } }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-layout-footer row">
        <div class="col-6">
          <button (click)="submit()" [disabled]="form.invalid || saving || cannotChangeCapacity" class="btn btn-block btn-primary bd-0"><i
            class="far fa-save"></i><span>{{ 'GENERIC.BUTTON.SAVE' | translate }}</span></button>
        </div>
        <div class="col-6">
          <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0"><i class="fas fa-ban"></i><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span></button>
        </div>
      </div>
    </div>
  </div>
</form>
